module.exports = __webpack_public_path__ + "img/mm-logo@1.5x.e26704ac.png";